import React from 'react';
import styled from 'styled-components';
import Intl from 'src/components/Intl';

import Form from 'components/Form/Form';

import vw from 'src/styles/utils';

function Register() {
  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root id="register">
            <Title>
              <span>{t.register.title[0]}</span>{t.register.title[1]}<br />
              {t.register.title[2]}
            </Title>
            <Form email={null} formType="Web" />
          </Root>
        );
      }}
    </Intl>
  );
};

const Root = styled.div`
  ${vw('padding-top', 42, 75, 122)}
  ${vw('padding-bottom', 66, 99, 105)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 100)}
`;

const Title = styled.h2`
  font-family: Gotham Black;
  font-style: normal;
  font-weight: 900;
  text-transform: uppercase;
  text-align: left;
  ${vw('font-size', 24, 43)}
  ${vw('line-height', 23, 41)}
  ${vw('letter-spacing', 0.2)}
  ${vw('margin-bottom', 24, 39, 31)}

  span {
    color: #DE5647;
  }
`;

export default Register

